import {
  BarChart3,
  CheckCircle2,
  Gauge,
  Layers,
  RotateCcw,
  Timer,
  type LucideIcon,
} from 'lucide-react';

/**
 * As abas de relatório e seus endereços.
 *
 * A lista mora aqui, e não dentro da tela, porque o roteador também precisa
 * dela: cada aba tem que ter rota registrada, e uma aba sem rota é 404 na cara
 * de quem clicou. Mesmo motivo de `features/admin/navegacao.ts`.
 */

export const RAIZ_DE_RELATORIOS = '/relatorios';

export const CAMINHOS = {
  volume: 'volume',
  ans: 'ans',
  resolucao: 'resolucao',
  backlog: 'backlog',
  reabertura: 'reabertura',
  fcr: 'fcr',
} as const;

export type CaminhoDeRelatorio = (typeof CAMINHOS)[keyof typeof CAMINHOS];

export interface AbaDeRelatorio {
  caminho: CaminhoDeRelatorio;
  rotulo: string;
  icone: LucideIcon;
  /** A pergunta que a aba responde, em uma linha, para o cabeçalho. */
  resumo: string;
}

export const ABAS: readonly AbaDeRelatorio[] = [
  {
    caminho: CAMINHOS.volume,
    rotulo: 'Volume',
    icone: BarChart3,
    resumo:
      'Quantos chamados entram e saem, e de onde vêm. A razão incidente/requisição fica aqui: é a mesma pergunta olhada por outro ângulo.',
  },
  {
    caminho: CAMINHOS.ans,
    rotulo: 'Cumprimento de ANS',
    icone: Gauge,
    resumo:
      'Dentro do prazo, em risco e violado — do acordo com o cliente (SLA), entre equipes (OLA) e com fornecedor (UC).',
  },
  {
    caminho: CAMINHOS.resolucao,
    rotulo: 'Tempo de resolução',
    icone: Timer,
    resumo:
      'MTRS em tempo útil, que desconta noite, fim de semana e feriado — ao lado do tempo corrido, rotulado como outra coisa.',
  },
  {
    caminho: CAMINHOS.backlog,
    rotulo: 'Backlog',
    icone: Layers,
    resumo:
      'O que está aberto agora e há quanto tempo. É foto, não período: o filtro de datas não muda esta aba.',
  },
  {
    caminho: CAMINHOS.reabertura,
    rotulo: 'Reabertura',
    icone: RotateCcw,
    resumo:
      'Quanto do que foi resolvido voltou. É o indicador que separa "fechou o chamado" de "resolveu o problema".',
  },
  {
    caminho: CAMINHOS.fcr,
    rotulo: 'FCR',
    icone: CheckCircle2,
    resumo:
      'First Contact Resolution — proporção de chamados resolvidos na primeira tentativa, sem nenhuma reabertura.',
  },
] as const;

export const abaDe = (caminho: string): AbaDeRelatorio | undefined =>
  ABAS.find((aba) => aba.caminho === caminho);
